import React, { useEffect, memo } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';

function Services() {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });
    }, []);

    return (
        <section id="services" className="services section">
            <div className="container section-title" data-aos="fade-up">
                <h2>Services</h2>
                <div>
                    <span>Check Our</span> <span className="description-title">Services</span>
                </div>
            </div>

            <div className="container mt-4" data-aos="fade-up" data-aos-delay="100">
                <div className="row">
                    <div className="col-md-4 col-sm-12 mb-4">
                        <div className="card hover-card1">
                            <div className="card-body">
                                <h5 className="card-title">PC & LAPTOP REPAIR</h5>
                                {/* <p className="card-text">Hardware & software troubleshooting, virus removal, data recovery.</p> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-sm-12 mb-4">
                        <div className="card hover-card2">
                            <div className="card-body">
                                <h5 className="card-title">PRINTER REPAIR</h5>
                                {/* <p className="card-text">All brands – laser, inkjet, dot matrix. AMC available.</p> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-sm-12 mb-4">
                        <div className="card hover-card3">
                            <div className="card-body">
                                <h5 className="card-title">SSD & HARD DISK</h5>
                                {/* <p className="card-text">Upgrade, replacement, data recovery & cloning.</p> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-sm-12 mb-4" data-aos="fade-up" data-aos-delay="200">
                        <div className="card hover-card4">
                            <div className="card-body">
                                <h5 className="card-title">CUSTOM PC BUILD</h5>
                                {/* <p className="card-text">Gaming, workstation, office – tailored to your needs.</p> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-sm-12 mb-4" data-aos="fade-up" data-aos-delay="200">
                        <div className="card hover-card5">
                            <div className="card-body">
                                <h5 className="card-title">SPARE PARTS</h5>
                                {/* <p className="card-text">Genuine components: RAM, motherboard, power supply, etc.</p> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-sm-12 mb-4" data-aos="fade-up" data-aos-delay="200">
                        <div className="card hover-card6">
                            <div className="card-body">
                                <h5 className="card-title">NETWORKING & AMC</h5>
                                {/* <p className="card-text">Wiring, router setup, annual maintenance contracts.</p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default memo(Services);